<main>
  <div class="search-wrapper">
    <div class="search-bar-wrapper">
      <div class="search-bar">
        <input
          type="text"
          class="form-control"
          placeholder="Search"
          [(ngModel)]="keyword"
          (ngModelChange)="filterMatchingOrders()"
        />
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
    </div>

    <div class="orders-filter-options">
      <!-- Filter Orders by state -->
      <div class="dropdown order-state">
        <label for="orderState">State</label>
        <button
          type="button"
          id="orderState"
          class="form-control dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          {{
            orderStateOption ? ORDER_TYPE_CONFIG[orderStateOption].label : "Any"
          }}
        </button>
        <ul class="dropdown-menu w-100">
          <li>
            <button
              type="button"
              class="dropdown-item"
              [class.selected]="!orderStateOption"
              (click)="updateOrderStateOption(undefined)"
            >
              Any
            </button>
          </li>
          @for (orderState of AVAILABLE_ORDER_STATES; track orderState) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="orderStateOption === orderState"
                (click)="updateOrderStateOption(orderState)"
              >
                {{ ORDER_TYPE_CONFIG[orderState].label }}
              </button>
            </li>
          }
        </ul>
      </div>

      <!-- Sort Orders -->
      <div class="dropdown sort-option">
        <label for="sortOption">Sort By</label>
        <button
          type="button"
          id="sortOption"
          class="form-control dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          {{ sortOption }}
        </button>
        <ul class="dropdown-menu w-100">
          @for (option of AVAILABLE_SORT_OPTIONS; track option) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="sortOption === option"
                (click)="updateSortOption(option)"
              >
                {{ option }}
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

  <ul class="orders-list">
    @for (order of shownOrders; track order.id) {
      <li>
        <oaibox-order-row
          class="flex-grow-1"
          [order]="order"
        ></oaibox-order-row>
      </li>
    } @empty {
      <li class="empty-list">
        <strong class="text-muted fs-5">No Orders</strong>
      </li>
    }
  </ul>
</main>
